/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFloppyStar: {
  name: 'floppy-star';
  data: string;
} = {
  name: 'floppy-star',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="m12 1-1 2H9l1.5 2-.5 2 2-1 2 1-.5-2L15 3h-2l-1-2ZM2 5.5A1.5 1.5 0 0 0 .5 7v7A1.5 1.5 0 0 0 2 15.5h7a1.5 1.5 0 0 0 1.5-1.5V9.114a1.5 1.5 0 0 0-.44-1.06L7.947 5.939a1.5 1.5 0 0 0-1.06-.439H2Zm4.5 9h-2V13a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1.5Zm1-1.5v1.5H9a.5.5 0 0 0 .5-.5V9.114a.5.5 0 0 0-.146-.353L7.239 6.646a.5.5 0 0 0-.353-.146H4.5V8a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1H5A1.5 1.5 0 0 1 3.5 8V6.5H2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h1.5V13A1.5 1.5 0 0 1 5 11.5h1A1.5 1.5 0 0 1 7.5 13Z" fill="currentColor"/></svg>`,
};
